import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, ChevronDown, Loader2 } from 'lucide-react';
import { useMemo, useState } from 'react';
/**
 * Displays a batched list of progress updates
 * Renders as a card with header and sequential task list
 */ export function ProgressPart({ progressName = 'Corporate Family Tree Discovery', progressParts, messageId }) {
    const [isExpanded, setIsExpanded] = useState(true);
    const isComplete = useMemo(()=>{
        const step = progressParts?.[progressParts.length - 1]?.data?.step || '';
        return step?.toLowerCase() === 'complete';
    }, [
        progressParts
    ]);
    // Don't render if there are no progress parts
    if (!progressParts || progressParts.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full border border-border rounded-lg overflow-hidden bg-card",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "px-4 py-3 border-b border-border bg-muted/50",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                                isComplete ? /*#__PURE__*/ _jsx(Check, {
                                    className: "h-5 w-5 text-green-500"
                                }) : /*#__PURE__*/ _jsx(Loader2, {
                                    className: "h-5 w-5 text-blue-500 animate-spin"
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "text-sm font-semibold text-foreground",
                                    children: progressName
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "text-xs text-muted-foreground",
                                    children: [
                                        progressParts.length,
                                        " ",
                                        progressParts.length === 1 ? 'step' : 'steps'
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: ()=>setIsExpanded(!isExpanded),
                                    className: "p-1 hover:bg-muted rounded transition-colors focus:outline-none focus:ring-2 focus:ring-ring",
                                    "aria-label": isExpanded ? 'Collapse progress details' : 'Expand progress details',
                                    "aria-expanded": isExpanded,
                                    children: /*#__PURE__*/ _jsx(ChevronDown, {
                                        className: `w-4 h-4 text-muted-foreground transition-transform ${isExpanded ? '' : '-rotate-90'}`
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ _jsx("div", {
                className: "px-4 py-3 space-y-2",
                children: progressParts.map(({ data }, idx)=>{
                    if (!data) return null;
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-start gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Check, {
                                className: "w-4 h-4 text-green-500 mt-0.5 flex-shrink-0"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-sm text-foreground break-words",
                                        children: data.content || 'Processing...'
                                    }),
                                    data.timestamp && /*#__PURE__*/ _jsx("span", {
                                        className: "text-xs text-muted-foreground",
                                        children: new Date(data.timestamp).toLocaleTimeString()
                                    })
                                ]
                            })
                        ]
                    }, `${messageId}-step-${idx}`);
                })
            })
        ]
    });
}
